(function () {
    'use strict';

    angular
        .module('initiativeUpdateStatusReviewRoutes')
        .controller('InitiativeUpdateStatusReviewDeliverablesListByQuarterController', Controller);

    Controller.$inject = ['$scope', '$timeout', '$state', '$stateParams', '$mdToast', 'permissionService', 'initiativeUpdateStatusService', 'pageDirtyService', 'govNotificationDelay'];

    function Controller($scope, $timeout, $state, $stateParams, $mdToast, permissionService, initiativeUpdateStatusService, pageDirtyService, govNotificationDelay) {
        init();

        // TODO: Use new data to check next/prev pages
        // Group by quarter
        $scope.ctrlCtxt.activeIndex = _.indexOf($scope.fiscalYearQuarterKeys, $stateParams.FiscalYearQuarterKey);
        $scope.ctrlCtxt.isNextInitiative = false;
        $scope.ctrlCtxt.activeQuarter = $stateParams.FiscalYearQuarterKey;
        $scope.ctrlCtxt.activeFiscalYear = $scope.deliverableAssessmentsByQuarter[0].MilestoneGroup.TargetFiscalYear;
        $scope.ctrlCtxt.activeQuarterTitle = $scope.deliverableAssessmentsByQuarter[0].MilestoneGroup.TargetDateQuarterShortTitleEN;
        $scope.ctrlCtxt.nextQuarter = null;
        $scope.ctrlCtxt.prevQuarter = null;

        $scope.ctrlCtxt.startForwardFlip = $stateParams.toNext !== false;
        $scope.ctrlCtxt.startBackwardFlip = $stateParams.toPrevious;
        $scope.ctrlCtxt.readyForAnimation = true;
        $scope.ctrlCtxt.hideContent = false;
        $scope.ctrlCtxt.moveForward = null;

        $scope.ctrlCtxt.initPlanQuarters = function () {
            if ($scope.fiscalYearQuarterKeys.length > 1
                && $scope.ctrlCtxt.activeIndex + 1 < $scope.fiscalYearQuarterKeys.length) {
                $scope.ctrlCtxt.nextQuarter = $scope.fiscalYearQuarterKeys[$scope.ctrlCtxt.activeIndex + 1];
            } else {
                $scope.ctrlCtxt.isNextInitiative = true;
            }

            if ($scope.ctrlCtxt.activeIndex > 0) {
                $scope.ctrlCtxt.prevQuarter = $scope.fiscalYearQuarterKeys[$scope.ctrlCtxt.activeIndex - 1];
            }
        };

        $scope.continueAssessment = function () {
            var dialogShown = pageDirtyService.showDialog();

            if (!dialogShown) {
                $scope.ctrlCtxt.moveForward = true;
                $scope.ctrlCtxt.hideContent = true;
                $timeout(function () {
                    $state.go('initiativeUpdateStatusReview.initiatives.review.byInitiative.deliverablesByQuarter', {
                        FiscalYearQuarterKey: $scope.ctrlCtxt.nextQuarter,
                        toNext: true,
                        toPrevious: false
                    });
                }, 150);
            }
        };

        $scope.goToPrevAssessment = function () {
            $scope.ctrlCtxt.moveBackwards = true;
            $scope.ctrlCtxt.hideContent = true;
            $timeout(function () {
                $state.go('initiativeUpdateStatusReview.initiatives.review.byInitiative.deliverablesByQuarter', {
                    FiscalYearQuarterKey: $scope.ctrlCtxt.prevQuarter,
                    toPrevious: true,
                    toNext: false
                });
            }, 150);
        };

        // Unlock Initiative
        $scope.unlockInitiative = function () {
            if (!$scope.assessmentByInitiative.PlanInitiativeAssessment.IsLocked) return;

            pageDirtyService.skipCheckForDirty();

            $scope.ctrlCtxt.isLoading = true;

            initiativeUpdateStatusService
                .unlockPlanInitiative($scope.assessmentByInitiative.PlanInitiativeAssessment)
                .then(function () {

                    $mdToast.show(
                        $mdToast
                            .simple()
                            .content('Initiative has been unlocked')
                            .position('top right')
                            .hideDelay($scope.govNotificationDelay)
                            .action('OK')
                            .theme('primary')
                    );

                    $state.reload();
                });
        };

        $scope.lockAssessment = function () {
            $scope.ctrlCtxt.isLoading = true;
            initiativeUpdateStatusService.lockPlanInitiativeAssessment(
                $scope.assessmentByInitiative.PlanInitiativeAssessment)
                .then(function () {
                    $state.reload();
                });
        };

        $scope.goToInitiative = function () {
            if ($scope.assessmentByInitiative.PlanInitiativeAssessment.AreAllDeliverablesReviewed) {
                $scope.ctrlCtxt.moveForward = true;
                $scope.ctrlCtxt.hideContent = true;
                $timeout(function () {
                    $state.go('initiativeUpdateStatusReview.initiatives.review.byInitiative.assessment');
                }, 150);
                return;
            }

            if (!$scope.isMissingAssessmentsShow) {
                $scope.isMissingAssessmentsShow = true;
                $timeout(function () {
                    $scope.isMissingAssessmentsShow = false;
                }, govNotificationDelay);
            }
        };

        function init() {
            $scope.ctrlCtxt = $scope.ctrlCtxt || {};
            $scope.ctrlCtxt.canEdit = permissionService.hasPermission('GRCInitiativeUpdateStatusManagement', 'PlanInitiative', 'ReviewAssessment');
            $scope.ctrlCtxt.isReadOnly = isReadOnly();
        }

        function isReadOnly() {
            if (!$scope.ctrlCtxt.canEdit) return;

            return $scope.assessmentByInitiative.PlanInitiativeAssessment.IsLocked;
        }
    }
})();
